
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"7","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10.714 1.22a.93.93 0 0 1-.277.665l-4 3.958a.935.935 0 1 1-1.316-1.33l4-3.957a.935.935 0 0 1 1.593.665"}}),_c('path',{attrs:{"d":"M6.713 5.178a.936.936 0 0 1-1.596.662L1.16 1.882A.936.936 0 0 1 2.483.56L6.44 4.517a.936.936 0 0 1 .273.661"}})])])
          )
        }
      }
    